import { render, staticRenderFns } from "./estudiosExternos.vue?vue&type=template&id=44c9c280"
import script from "./estudiosExternos.vue?vue&type=script&lang=js"
export * from "./estudiosExternos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports